'use strict';

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _assertThisInitialized = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _wrapNativeSuper = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var NonError =
/*#__PURE__*/
function (_Error) {
  _inherits(NonError, _Error);

  function NonError(message) {
    var _this;

    _classCallCheck(this, NonError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NonError).call(this, NonError._prepareSuperMessage(message)));
    Object.defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), 'name', {
      value: 'NonError',
      configurable: true,
      writable: true
    });

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_assertThisInitialized(_this)), NonError);
    }

    return _this;
  }

  _createClass(NonError, null, [{
    key: "_prepareSuperMessage",
    value: function _prepareSuperMessage(message) {
      try {
        return JSON.stringify(message);
      } catch (_unused) {
        return String(message);
      }
    }
  }]);

  return NonError;
}(_wrapNativeSuper(Error));

var commonProperties = [{
  property: 'name',
  enumerable: false
}, {
  property: 'message',
  enumerable: false
}, {
  property: 'stack',
  enumerable: false
}, {
  property: 'code',
  enumerable: true
}];
var isCalled = Symbol('.toJSON called');

var toJSON = function toJSON(from) {
  from[isCalled] = true;
  var json = from.toJSON();
  delete from[isCalled];
  return json;
};

var destroyCircular = function destroyCircular(_ref) {
  var from = _ref.from,
      seen = _ref.seen,
      to_ = _ref.to_,
      forceEnumerable = _ref.forceEnumerable,
      maxDepth = _ref.maxDepth,
      depth = _ref.depth;
  var to = to_ || (Array.isArray(from) ? [] : {});
  seen.push(from);

  if (depth >= maxDepth) {
    return to;
  }

  if (typeof from.toJSON === 'function' && from[isCalled] !== true) {
    return toJSON(from);
  }

  for (var _i = 0, _Object$entries = Object.entries(from); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    if (typeof Buffer === 'function' && Buffer.isBuffer(value)) {
      to[key] = '[object Buffer]';
      continue;
    }

    if (typeof value === 'function') {
      continue;
    }

    if (!value || typeof value !== 'object') {
      to[key] = value;
      continue;
    }

    if (!seen.includes(from[key])) {
      depth++;
      to[key] = destroyCircular({
        from: from[key],
        seen: seen.slice(),
        forceEnumerable: forceEnumerable,
        maxDepth: maxDepth,
        depth: depth
      });
      continue;
    }

    to[key] = '[Circular]';
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = commonProperties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _step$value = _step.value,
          property = _step$value.property,
          enumerable = _step$value.enumerable;

      if (typeof from[property] === 'string') {
        Object.defineProperty(to, property, {
          value: from[property],
          enumerable: forceEnumerable ? true : enumerable,
          configurable: true,
          writable: true
        });
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return to;
};

var serializeError = function serializeError(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$maxDepth = options.maxDepth,
      maxDepth = _options$maxDepth === void 0 ? Number.POSITIVE_INFINITY : _options$maxDepth;

  if (typeof value === 'object' && value !== null) {
    return destroyCircular({
      from: value,
      seen: [],
      forceEnumerable: true,
      maxDepth: maxDepth,
      depth: 0
    });
  } // People sometimes throw things besides Error objects…


  if (typeof value === 'function') {
    // `JSON.stringify()` discards functions. We do too, unless a function is thrown directly.
    return "[Function: ".concat(value.name || 'anonymous', "]");
  }

  return value;
};

var deserializeError = function deserializeError(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$maxDepth2 = options.maxDepth,
      maxDepth = _options$maxDepth2 === void 0 ? Number.POSITIVE_INFINITY : _options$maxDepth2;

  if (value instanceof Error) {
    return value;
  }

  if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
    var newError = new Error(); // eslint-disable-line unicorn/error-message

    destroyCircular({
      from: value,
      seen: [],
      to_: newError,
      maxDepth: maxDepth,
      depth: 0
    });
    return newError;
  }

  return new NonError(value);
};

module.exports = {
  serializeError: serializeError,
  deserializeError: deserializeError
};